/**
 * UI copy lives in `src/locales/*.json`. To add a language: add `xx.json`
 * (same keys as `en.json`), extend `LanguageCode` in game types, and register
 * it on `UI_MESSAGES` below.
 */
import type { LanguageCode } from '../game/types'
import en from '../locales/en.json'
import nl from '../locales/nl.json'

/** Ensures both locale files expose the same keys (compile-time check). */
nl satisfies Record<keyof typeof en, string>
en satisfies Record<keyof typeof nl, string>

export type MessageKey = keyof typeof en

export const UI_MESSAGES: Record<LanguageCode, Record<MessageKey, string>> = {
  en,
  nl,
}
